import {featureToggles} from "./properties/AppPropertiesProxy";
import {logInfo, logError} from "./common/Logger";
import babelPolyfill from 'babel-polyfill';

logInfo("Starting root index.js");

// Toggling between Romer vs Artistarchus temporarily
if (featureToggles.ARISTARCHUS_IS_ACTIVE) {
    import('./_aristarchus/index.js')
        .then(module => {
            logInfo("aristarchus-index module imported");
        })
        .catch(err => {
            logError("import of aristarchus-index module failed. Err: " + err.message);
        });
} else {
    import('./romer-index.js')
        .then(module => {
            logInfo("romer-index module imported");
        })
        .catch(err => {
            logError("import of romer-index module failed. Err: " + err.message);
        });
}



// WEBPACK FOOTER //
// ./src/index.js